/*! @azure/msal-browser v3.10.0 2024-02-17 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-browser";
const version = "3.10.0";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
